<template>
  <div class="receipt-print-config-page">
    <div class="back-header">
      <div class="back-btn" @click="$router.back()">←</div>
      <h1>{{ $t('receiptPrintConfig.title') }}</h1>
      <div style="flex: 1;"></div>
    </div>

    <div class="page-content">
      <!-- 批发商信息 -->
      <div class="config-section">
        <h3>🏢 {{ $t('receiptPrintConfig.wholesalerInfo.title') }}</h3>
        <div class="form-item">
          <label>{{ $t('receiptPrintConfig.wholesalerInfo.name') }}</label>
          <input type="text" v-model="config.wholesalerName" :placeholder="$t('receiptPrintConfig.placeholder')" />
        </div>
        <div class="form-item">
          <label>{{ $t('receiptPrintConfig.wholesalerInfo.address') }}</label>
          <input type="text" v-model="config.wholesalerAddress" :placeholder="$t('receiptPrintConfig.placeholder')" />
        </div>
        <div class="form-item">
          <label>{{ $t('receiptPrintConfig.wholesalerInfo.phone') }}</label>
          <input type="text" v-model="config.wholesalerPhone" :placeholder="$t('receiptPrintConfig.placeholder')" />
        </div>
        <div class="form-item">
          <label>{{ $t('receiptPrintConfig.wholesalerInfo.taxNo') }}</label>
          <input type="text" v-model="config.wholesalerTaxNo" :placeholder="$t('receiptPrintConfig.wholesalerInfo.taxNoHint')" />
        </div>
        <div class="form-item">
          <label>{{ $t('receiptPrintConfig.wholesalerInfo.paynowQr') }}</label>
          <div class="qr-upload" @click="triggerQrUpload('wholesalerPaynowQr')">
            <img v-if="config.wholesalerPaynowQr" :src="getImageUrl(config.wholesalerPaynowQr)" class="qr-preview" />
            <div v-else class="qr-placeholder">
              <span>📱</span>
              <p>{{ $t('receiptPrintConfig.uploadQr') }}</p>
            </div>
          </div>
          <input ref="wholesalerPaynowQrInput" type="file" accept="image/*" style="display:none" @change="handleQrUpload($event, 'wholesalerPaynowQr')" />
        </div>
      </div>

      <!-- 银行信息 -->
      <div class="config-section">
        <h3>🏦 {{ $t('receiptPrintConfig.bankInfo.title') }}</h3>
        <div class="form-item">
          <label>{{ $t('receiptPrintConfig.bankInfo.name') }}</label>
          <input type="text" v-model="config.bankName" :placeholder="$t('receiptPrintConfig.placeholder')" />
        </div>
        <div class="form-item">
          <label>{{ $t('receiptPrintConfig.bankInfo.accountName') }}</label>
          <input type="text" v-model="config.bankAccountName" :placeholder="$t('receiptPrintConfig.placeholder')" />
        </div>
        <div class="form-item">
          <label>{{ $t('receiptPrintConfig.bankInfo.accountNo') }}</label>
          <input type="text" v-model="config.bankAccountNumber" :placeholder="$t('receiptPrintConfig.placeholder')" />
        </div>
      </div>

      <!-- 档口信息 -->
      <div class="config-section stall-info-section">
        <h3>🏪 {{ $t('receiptPrintConfig.stallInfo.title') }}</h3>
        <div class="info-hint">
          <span class="hint-icon">💡</span>
          <p class="hint-text">{{ $t('receiptPrintConfig.stallInfo.hint') }}</p>
        </div>
        <div class="info-hint">
          <span class="hint-icon">ℹ️</span>
          <p class="hint-text">{{ $t('receiptPrintConfig.stallInfo.hint2') }}</p>
        </div>
      </div>

      <!-- GST 发票设置 -->
      <div class="config-section gst-section">
        <h3>📄 {{ $t('receiptPrintConfig.gst.title') }}</h3>
        <div class="toggle-row">
          <span class="toggle-label">{{ $t('receiptPrintConfig.gst.registered') }}</span>
          <label class="switch">
            <input type="checkbox" v-model="config.gstRegistered" />
            <span class="slider"></span>
          </label>
        </div>
        <p class="toggle-hint">{{ $t('receiptPrintConfig.gst.hint') }}</p>
        <div class="form-item" v-if="config.gstRegistered">
          <label>{{ $t('receiptPrintConfig.gst.rate') }}</label>
          <input type="number" v-model.number="config.gstRate" placeholder="9" step="0.1" />
          <p class="field-hint">{{ $t('receiptPrintConfig.gst.rateHint') }}</p>
        </div>
        <div class="form-item" v-if="config.gstRegistered">
          <label>{{ $t('receiptPrintConfig.gst.no') }}</label>
          <input type="text" v-model="config.gstNo" :placeholder="$t('receiptPrintConfig.gst.noHint')" />
        </div>
      </div>

      <!-- 打印内容选项 -->
      <div class="config-section">
        <h3>📋 {{ $t('receiptPrintConfig.content.title') }}</h3>
        <div class="checkbox-item">
          <label><input type="checkbox" v-model="config.showWholesalerInfo" /> {{ $t('receiptPrintConfig.content.wholesalerInfo') }}</label>
        </div>
        <div class="checkbox-item">
          <label><input type="checkbox" v-model="config.showStallInfo" /> {{ $t('receiptPrintConfig.content.stallInfo') }}</label>
        </div>
        <div class="checkbox-item">
          <label><input type="checkbox" v-model="config.showBankInfo" /> {{ $t('receiptPrintConfig.content.bankInfo') }}</label>
        </div>
        <div class="checkbox-item">
          <label><input type="checkbox" v-model="config.showPaynowQr" /> {{ $t('receiptPrintConfig.content.paynowQr') }}</label>
        </div>
        <div class="checkbox-item">
          <label><input type="checkbox" v-model="config.showGstDetail" /> {{ $t('receiptPrintConfig.content.gstDetail') }}</label>
        </div>
      </div>

      <div class="save-section">
        <button class="btn-save" @click="saveConfig">{{ $t('receiptPrintConfig.save') }}</button>
      </div>
      <div class="preview-section">
        <button class="btn-preview" @click="showPreview = true">{{ $t('receiptPrintConfig.preview') }}</button>
      </div>
    </div>

    <div v-if="showToast" class="toast">{{ toastMessage }}</div>
    <PrintPreview :visible.sync="showPreview" :config="config" :order="mockOrder" />
  </div>
</template>

<script>
import api, { uploadFile } from '@/services/api';
import { getWholesalerId } from '@/utils/wholesaler';
import PrintPreview from '@/components/PrintPreview.vue';
import { getImageUrl } from '@/utils/image';

export default {
  name: 'ReceiptPrintConfig',
  components: { PrintPreview },
  data() {
    return {
      showToast: false,
      toastMessage: '',
      showPreview: false,
      config: {
        wholesalerName: '', wholesalerAddress: '', wholesalerPhone: '', wholesalerTaxNo: '', wholesalerPaynowQr: '',
        bankName: '', bankAccountName: '', bankAccountNumber: '',
        gstRegistered: false, gstRate: 9, gstNo: '',
        showWholesalerInfo: true, showStallInfo: true, showBankInfo: true, showPaynowQr: true, showGstDetail: true
      },
      mockOrder: {
        stallName: '示例档口 / Sample Stall', stallTaxNo: 'M2-1234567-X',
        deliveryAddress: '新加坡 XX 街 XX 号', receiverName: '张三', receiverPhone: '+65 9123 4567', remark: '放门口即可'
      }
    };
  },
  mounted() { this.loadConfig(); this.loadShopInfo(); },
  methods: {
    getImageUrl,
    async loadConfig() {
      try {
        const wid = getWholesalerId();
        if (!wid) { this.showToastMsg('未找到商户信息'); return; }
        const res = await api.get('/printer/config', { params: { wholesalerId: wid } });
        if (res) this.config = { ...this.config, ...res };
      } catch (e) { console.error('加载打印配置失败:', e); }
    },
    async loadShopInfo() {
      try {
        const wid = getWholesalerId();
        if (!wid) return;
        const res = await api.get('/shop/info', { params: { wholesalerId: wid } });
        if (res) {
          if (!this.config.wholesalerName && res.companyName) this.config.wholesalerName = res.companyName;
          if (!this.config.wholesalerAddress && res.address) this.config.wholesalerAddress = res.address;
          if (!this.config.wholesalerPhone && res.contactPhone) this.config.wholesalerPhone = res.contactPhone;
          if (!this.config.wholesalerPaynowQr && res.paynowQrUrl) this.config.wholesalerPaynowQr = res.paynowQrUrl;
          if (!this.config.bankName && res.bankName) this.config.bankName = res.bankName;
          if (!this.config.bankAccountName && res.bankAccountName) this.config.bankAccountName = res.bankAccountName;
          if (!this.config.bankAccountNumber && res.bankAccountNumber) this.config.bankAccountNumber = res.bankAccountNumber;
        }
      } catch (e) { console.error('加载店铺信息失败:', e); }
    },
    triggerQrUpload(field) { this.$refs[field + 'Input'].click(); },
    async handleQrUpload(event, field) {
      const file = event.target.files[0];
      if (!file) return;
      try {
        this.showToastMsg('正在上传...');
        const result = await uploadFile('/files/upload-image', file);
        if (result && result.url) { this.config[field] = result.url; this.showToastMsg('✅ 上传成功'); }
      } catch (e) { this.showToastMsg('上传失败'); }
      finally { event.target.value = ''; }
    },
    async saveConfig() {
      try {
        const wid = getWholesalerId();
        if (!wid) { this.showToastMsg('未找到商户信息'); return; }
        await api.post('/printer/config/save', this.config, { params: { wholesalerId: wid } });
        this.showToastMsg('✅ 保存成功');
      } catch (e) { this.showToastMsg('保存失败：' + (e.message || '')); }
    },
    showToastMsg(msg) { this.toastMessage = msg; this.showToast = true; setTimeout(() => { this.showToast = false; }, 2500); }
  }
};
</script>

<style scoped>
.receipt-print-config-page { min-height: 100vh; background: #f5f7fa; padding-bottom: 80px; }
.back-header { display: flex; align-items: center; padding: calc(12px + env(safe-area-inset-top, 0px)) 16px; background: #fff; border-bottom: 1px solid #e8e8e8; position: sticky; top: 0; z-index: 100; }
.back-btn { width: 36px; height: 36px; display: flex; align-items: center; justify-content: center; cursor: pointer; font-size: 20px; }
.back-header h1 { flex: 1; font-size: 18px; font-weight: 600; text-align: center; margin: 0 12px; }
.page-content { padding: 12px; }
.config-section { background: #fff; border-radius: 12px; padding: 16px; margin-bottom: 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
.config-section h3 { margin: 0 0 16px 0; font-size: 15px; font-weight: 600; color: #333; }
.form-item { margin-bottom: 16px; }
.form-item:last-child { margin-bottom: 0; }
.form-item label { display: block; font-size: 13px; font-weight: 600; margin-bottom: 8px; color: #555; }
.form-item input, .form-item textarea { width: 100%; padding: 10px 12px; border: 1px solid #e0e0e0; border-radius: 8px; font-size: 14px; box-sizing: border-box; }
.form-item input:focus, .form-item textarea:focus { border-color: #667eea; outline: none; }
.field-hint { font-size: 12px; color: #999; margin-top: 4px; }
.toggle-row { display: flex; justify-content: space-between; align-items: center; padding: 8px 0; }
.toggle-label { font-size: 14px; color: #333; }
.toggle-hint { font-size: 12px; color: #999; margin: 4px 0 0 0; }
.switch { position: relative; display: inline-block; width: 50px; height: 28px; }
.switch input { opacity: 0; width: 0; height: 0; }
.slider { position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0; background-color: #ccc; transition: 0.3s; border-radius: 28px; }
.slider:before { position: absolute; content: ""; height: 22px; width: 22px; left: 3px; bottom: 3px; background-color: white; transition: 0.3s; border-radius: 50%; }
input:checked + .slider { background-color: #667eea; }
input:checked + .slider:before { transform: translateX(22px); }
.qr-upload { width: 100%; padding: 16px; background: #f8f9fa; border: 2px dashed #e0e0e0; border-radius: 8px; text-align: center; cursor: pointer; }
.qr-upload:hover { border-color: #667eea; background: #f0f2ff; }
.qr-preview { max-width: 200px; max-height: 200px; border-radius: 8px; }
.qr-placeholder { display: flex; flex-direction: column; align-items: center; color: #999; }
.qr-placeholder span { font-size: 40px; margin-bottom: 8px; }
.qr-placeholder p { margin: 0; font-size: 13px; }
.checkbox-item { padding: 10px 0; border-bottom: 1px dashed #f0f0f0; }
.checkbox-item:last-child { border-bottom: none; }
.checkbox-item label { display: flex; align-items: center; gap: 10px; cursor: pointer; font-size: 14px; color: #333; }
.checkbox-item input[type="checkbox"] { width: 18px; height: 18px; accent-color: #667eea; }
.gst-section { border: 2px solid #38bdf8; background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%); }
.gst-section h3 { color: #1e40af; }
.stall-info-section { border: 2px solid #a78bfa; background: linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%); }
.stall-info-section h3 { color: #6d28d9; }
.info-hint { display: flex; align-items: flex-start; gap: 10px; padding: 10px 12px; background: rgba(255,255,255,0.7); border-radius: 8px; margin-bottom: 10px; }
.info-hint:last-child { margin-bottom: 0; }
.hint-icon { font-size: 20px; flex-shrink: 0; }
.hint-text { margin: 0; font-size: 13px; color: #4b5563; line-height: 1.5; }
.save-section, .preview-section { padding: 12px; }
.btn-save, .btn-preview { width: 100%; padding: 14px; border: none; border-radius: 10px; font-size: 15px; font-weight: 600; cursor: pointer; }
.btn-save { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: #fff; }
.btn-save:active { opacity: 0.9; transform: scale(0.98); }
.btn-preview { background: #fff; color: #667eea; border: 2px solid #667eea; }
.btn-preview:active { background: #f0f2ff; }
.toast { position: fixed; bottom: 80px; left: 50%; transform: translateX(-50%); background: rgba(0,0,0,0.8); color: #fff; padding: 12px 20px; border-radius: 20px; font-size: 13px; z-index: 2000; }
</style>